/* eslint-disable global-require */
// @flow

import CookieService from 'app/common/services/cookie';
import log from 'app/common/utils/log';
import StringUtils from 'app/common/utils/string';
import { format } from 'react-string-format';

type Translation = {
  [key: string]: string,
};

type AllTranslations = {
  en: Translation,
  de: Translation,
  es: Translation,
  sp: Translation,
  fr: Translation,
  it: Translation,
  nl: Translation,
  pb: Translation,
  zh: Translation,
  cn: Translation,
  ja: Translation,
  ko: Translation,
  ru: Translation,
  ar: Translation,
  vi: Translation,
  id: Translation,
};

const TRANSLATION_COOKIE = 'LanguageCode';
const LANGUAGE_SUPPORTS = [
  'en',
  'de',
  'es',
  'sp',
  'fr',
  'it',
  'nl',
  'pb',
  'zh',
  'cn',
  'ja',
  'ko',
  'ru',
  'ar',
  'vi',
  'id',
];
const DEFAULT_LANGUAGE_CODE = 'en';

const getTranslationsFromModules = () => {
  const common = require('app/common/i18n').default;
  const documentIndex = require('app/pages/i18n').default;

  return {
    common,
    documentIndex,
  };
};

const getTranslations = (): AllTranslations => {
  const allTranslations = getTranslationsFromModules();

  const modulesKey = Object.keys(allTranslations);
  const translations = {};

  LANGUAGE_SUPPORTS.forEach((languageCode: any) => {
    modulesKey.forEach((moduleKey) => {
      if (allTranslations[moduleKey][languageCode]) {
        translations[languageCode] = {
          ...translations[languageCode],
          ...allTranslations[moduleKey][languageCode],
        };
      } else {
        translations[languageCode] = {
          ...translations[languageCode],
          ...allTranslations[moduleKey][DEFAULT_LANGUAGE_CODE],
        };
      }
    });
  });

  return translations;
};

const allTranslations = getTranslations();

const TranslationService = {
  current: allTranslations[DEFAULT_LANGUAGE_CODE],

  getLanguageCode() {
    return CookieService.getCookie(TRANSLATION_COOKIE) || DEFAULT_LANGUAGE_CODE;
  },
  changeLanguage() {
    const languageCode = this.getLanguageCode().toLowerCase();

    this.current = allTranslations[languageCode];
  },
  get(key: string) {
    const value = this.current[key];

    if (!value) {
      log.error(new Error(`TRANSLATION_KEY: ${key} is not provided`));

      return key;
    }

    return value;
  },
  format(key: string, ...args: any[]) {
    const translationText = this.get(key);

    return format(translationText, ...args);
  },
  replaceTags(key: string, params: Object) {
    const translationText = this.get(key);

    const replaceParams = params || {};

    return StringUtils.format(translationText, replaceParams);
  },
  joinByTranslationKeys(keys: string[]) {
    return keys
      .map((key) => {
        return TranslationService.get(key);
      })
      .join(' ');
  },
  getUserTypeByCode(code: string) {
    return this.get(`UserTypeCode_${code}`);
  },
  getQnaRoleByCode(code: string) {
    return this.get(`QnaRoleCode_${code}`);
  },
  getPluralizedWord(translationKey: string, count: number) {
    if (count === 1) {
      return this.get(`${translationKey}_Singular`);
    }
    return this.get(`${translationKey}_Plural`);
  },
};

export default TranslationService;
